import script from "./OrderComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__